export default {
    letters: {
        en: [
            'A',
            'B',
            'C',
            'D',
            'E',
            'F',
            'G',
            'H',
            'I',
            'J',
            'K',
            'L',
            'M',
            'N',
            'O',
            'P',
            'Q',
            'R',
            'S',
            'T',
            'U',
            'V',
            'W',
            'X',
            'Y',
            'Z',
        ],
        ru: [
            'А',
            'Б',
            'В',
            'Г',
            'Д',
            'Е',
            'Ё',
            'Ж',
            'З',
            'И',
            'Й',
            'К',
            'Л',
            'М',
            'Н',
            'О',
            'П',
            'Р',
            'С',
            'Т',
            'У',
            'Ф',
            'Х',
            'Ц',
            'Ч',
            'Ш',
            'Щ',
            'Э',
            'Ю',
            'Я',
        ],
        uk: [
            'А',
            'Б',
            'В',
            'Г',
            'Д',
            'Е',
            'Є',
            'Ж',
            'З',
            'И',
            'Ї',
            'Й',
            'К',
            'Л',
            'М',
            'Н',
            'О',
            'П',
            'Р',
            'С',
            'Т',
            'У',
            'Ф',
            'Х',
            'Ц',
            'Ч',
            'Ш',
            'Щ',
            'Ю',
            'Я',
        ],
        lv: [
            'A',
            'Ā',
            'B',
            'C',
            'Č',
            'D',
            'E',
            'Ē',
            'F',
            'G',
            'Ģ',
            'H',
            'I',
            'Ī',
            'J',
            'K',
            'Ķ',
            'L',
            'Ļ',
            'M',
            'N',
            'Ņ',
            'O',
            'P',
            'Q',
            'R',
            'S',
            'Š',
            'T',
            'U',
            'Ū',
            'V',
            'Z',
            'Ž',
        ],
        fr: [
            'A',
            'B',
            'C',
            'D',
            'E',
            'F',
            'G',
            'H',
            'I',
            'J',
            'K',
            'L',
            'M',
            'N',
            'O',
            'P',
            'Q',
            'R',
            'S',
            'T',
            'U',
            'V',
            'W',
            'X',
            'Y',
            'Z',
        ],
        bg: [
            'А',
            'Б',
            'В',
            'Г',
            'Д',
            'Е',
            'Ж',
            'З',
            'И',
            'Й',
            'К',
            'Л',
            'М',
            'Н',
            'О',
            'П',
            'Р',
            'С',
            'Т',
            'У',
            'Ф',
            'Х',
            'Ц',
            'Ч',
            'Ш',
            'Щ',
            'Ю',
            'Я',
        ],
    },
    digits: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    figures: [
        'circle',
        'horizontalLine',
        'square',
        'triangleDown',
        'triangleUp',
        'verticalLine',
        'zigZag',
        'diagonalEllipse',
        'diagonalEllipse2',
        'diagonalTrapezoid',
        'heart',
        'hexagon',
        'horizontalDiamond',
        'horizontalEllipse',
        'rhombus',
        'star',
        'trapezoidDown',
        'trapezoidUp',
        'verticalDiamond',
        'verticalEllipse',
    ],
};
